import { Button, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { UsuariosService } from "../../../../services/api/Usuarios/UsuariosService";
import ModalSimNao from "../../../../components/ModalSimNao";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilSquare, faPenToSquare, faPlus, faPlusCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import PaginacaoLinks from "../../../../components/Paginacao/PaginacaoLinks";
import Loading from "../../../../components/Loader/Loading";
import ConfiguracoesSistemaPrincipal from "../../ConfiguracoesSistemaPrincipal";
import { PermissoesService } from "../../../../services/api/Usuarios/PermissoesService";
import PermissoesComponent from "../../../../components/PermissaoComponent";
import { usePermissoes } from "../../../../hooks/usePermissoes";


const GruposUsuarios = () => {

    const [listGrupos, setListGrupos] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [dadosPaginacao, setDadosPaginacao] = useState(null)
    const [page, setPage] = useState(null)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 10, acoesId: 1 },
        { secoesId: 10, acoesId: 2 },
        { secoesId: 10, acoesId: 3 },
        { secoesId: 10, acoesId: 4 }
    ])

    const fetchGrupos = async () => {
        setIsloading(true);
        const data = await PermissoesService.getPermissoesGrupos(page)

        if (data.success) {
            setListGrupos(data.data)
            setDadosPaginacao(data.meta)
        }
        setIsloading(false);
    }

    useEffect(() => {
        fetchGrupos()
    }, [page])

    //console.log(listGrupos)



    const handleDelete = (id) => {
        setIdDelete(id)
        setShowModal(true)
    }
    const handleClose = () => {
        setShowModal(false)
        setIdDelete(null)
    }
    const handleConfirmDelete = async () => {
        const usuario = await UsuariosService.deleteById(idDelete)
        handleClose();
        fetchGrupos()
    }
    const onClickPage = (page) => {
        setPage(page)
    }

    return (
        <>
            <ConfiguracoesSistemaPrincipal>
                <h3><span className="mr-15">Grupos de Usuário</span> <Button className="" variant="success" size="sm" href="/admin/configuracoes/gruposUsuarios/cadEdit"> <FontAwesomeIcon icon={faPlusCircle} /> Adicionar grupo</Button> </h3>
                <hr></hr>

                {(isLoading) ? <Loading /> : (
                    <>
                        {(!listPermissoes?.ver && !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                            <>

                                {(listGrupos.length > 0) ?
                                    <>
                                        <Table bordered striped responsive size="sm">

                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listGrupos.map((item, key) => (

                                                    <tr key={key}>
                                                        <td>{item.nome}</td>
                                                        <td className="text-center">
                                                            <Button variant="primary" size="sm" title="Editar" className="mr-10" href={'/admin/configuracoes/gruposUsuarios/cadEdit/' + item.id}><FontAwesomeIcon icon={faPenToSquare} /> </Button>
                                                            <Button variant="danger" size="sm" title="Ecluir" onClick={() => handleDelete(item.id)}><FontAwesomeIcon icon={faTrash} />  </Button>
                                                        </td>
                                                    </tr>

                                                ))}
                                            </tbody>

                                        </Table>

                                        <PaginacaoLinks totalPages={dadosPaginacao?.last_page}
                                            currentPage={dadosPaginacao?.current_page}
                                            onClickPage={onClickPage}
                                        ></PaginacaoLinks>

                                    </>

                                    : <div className="alert alert-warning text-center">Sem usuários registrados</div>}

                            </>)}
                    </>)}

                <ModalSimNao handleClose={handleClose} handleConfirm={handleConfirmDelete} show={showModal}>
                    Tem certeza que deseja excluir este usuário?
                </ModalSimNao>

            </ConfiguracoesSistemaPrincipal>

        </>
    )

}

export default GruposUsuarios;